import * as React from 'react';

import type {SalesDocumentUpdateInput} from 'nutshell-graphql-types';

import {SaveableWrapper} from '../../saveable-wrapper/saveable-wrapper';

import {QuoteTextArea} from '../editable/quote-text-area';
import {PAYMENT_INFO} from '../helpers';
import {QuoteNoteSection} from '../read-only/quote-note-section';

import styles from '../quote.module.css';

type Props = {
    id: string;
    onSave: (arg1: SalesDocumentUpdateInput) => void;
    onCancel: () => void;
    isActive: boolean;
    paymentInfo: string;
    onToggleActive: (arg1: string) => void;
    isTemplate: boolean;
    isImmutable: boolean;
    forceSave: boolean;
};

export function InvoicePaymentInfoWrapper(props: Props) {
    const {id, onSave} = props;
    const [paymentInfo, setPaymentInfo] = React.useState<string>(props.paymentInfo);

    React.useEffect(() => {
        setPaymentInfo(props.paymentInfo);
    }, [props.paymentInfo]);

    const handleSave = React.useCallback(() => {
        onSave({
            salesDocument: id,
            paymentAndTerms: paymentInfo,
        });
    }, [id, paymentInfo, onSave]);

    const handleCancel = () => {
        setPaymentInfo(props.paymentInfo);
        props.onCancel();
    };

    React.useEffect(() => {
        if (props.forceSave) {
            handleSave();
        }
    }, [props.forceSave, handleSave]);

    return (
        <SaveableWrapper
            isActive={props.isActive}
            onSave={handleSave}
            onCancel={handleCancel}
            onToggleActive={props.onToggleActive}
            // @ts-expect-error
            sectionName={PAYMENT_INFO}
            noPadding={true}
            isImmutable={props.isImmutable}
            showEditIcon={props.isTemplate}
        >
            {props.isActive ? (
                <div className={styles['editable-footer-wrapper']}>
                    <QuoteTextArea
                        value={paymentInfo}
                        onChange={setPaymentInfo}
                        bottomPaddingForToolbar={true}
                        largerText={true}
                        isFullHeight={false}
                    />
                </div>
            ) : (
                <div className={styles['read-only-footer-wrapper']}>
                    <QuoteNoteSection
                        text={paymentInfo}
                        placeholder='Add payment methods and how to pay information'
                    />
                </div>
            )}
        </SaveableWrapper>
    );
}
